import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
// import convertToExcel from "../../../../components/ExportToExcel";
// import convertToExcel from "./ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
const AgriFarmersEnrollmentTemplate = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [stateData, setStatedata] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [stateId, setStateId] = useState();
  const [stateName, setStateName] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getFarmerEnrollmentTemplateData } = useHttp();

  const fillFarmerEnrollmentTemplateData = (
    employeeId,
    stateName,
    farmerNo,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `/api/farmerEnrolmentReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getFarmerEnrollmentTemplateData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillFarmerEnrollmentTemplateData(0, 0, "");
  }, [getFarmerEnrollmentTemplateData]);

  const fieldsToExport = [
    "farmerNo",
    // "farmerphoto",
    "registrationDate",
    "farmerName",
    "plotSizeInHa",
    "gender",
    "mobile",
    // "bvn",
    "seasonName",
    // "farmerStatus",
    "farmerEducation",
    // "religion",
    "dob",
    "ageRange",
    // "maritalStatus",
     "category",
    "address",
    "state",
    "lga",
    "villageName",
    // "accountNumber",
    // "accountType",
    // "bankName",
    "executiveName",
    "enrollmentPlace",
    // "signature",
    "createdDate",
  ];

  const customHeaders = [
    "Farmer Id",
    // "Farmer Photo",
    "Registration Date",
    "Farmer Name",
    "Demo Plot Size(sq.m.)",
    "Plot Size(sq.m.)",
    "Gender",
    "Mobile",
    // "BVN",
    "Season",
    // "Farmer Status",
    "Farmer Education",
    // "Religion",
    "DOB",
    "Age Range",
    // "Marital Status",
    "Category ",
    "Farmer Address",
    "State",
    "LGA",
    "Village",
    // "Account Number",
    // "Account Name",
    // "Bank Name",
    "Enrolled By",
    "Enrolled Place",
    // "Signature",
    "Created Date",
  ];


  const handleExportExcel = () => {
      const headers = [
        "Farmer Id",    
    "Registration Date",
    "Farmer Name",
    "Demo Plot Size(sq.m.)",
    "Plot Size(sq.m.)",
    "Gender",
    "Mobile",
    // "BVN",
    "Season",
    // "Farmer Status",
    "Farmer Education",
    // "Religion",
    "DOB",
    "Age Range",
    // "Marital Status",
    "Category ",
    "Farmer Address",
    "State",
    "LGA",
    "Village",
    // "Account Number",
    // "Account Name",
    // "Bank Name",
    "Enrolled By",
    "Enrolled Place",
    "Created Date",
     "Farmer Photo",
     "Signature",
    
      ];
    
      const worksheet = XLSX.utils.aoa_to_sheet([headers]);
    
      // Function to get column widths based on data
      const getColumnWidths = (dataArray, headersArray) => {
        return headersArray.map((header, colIndex) => {
          const maxTextLength = Math.max(
            header.length,
            ...dataArray.map(
              (item) => String(Object.values(item)[colIndex] || "").length
            )
          );
          return { wch: maxTextLength + 5 }; // Extra width for links
        });
      };
    
      // Function to get row heights for Excel
      const getRowHeights = (rowCount) => {
        return Array.from({ length: rowCount + 1 }, (_, index) => ({
          hpt: index === 0 ? 20 : 18, // Header row is taller
        }));
      };
    
      let currentRowIndex = 2; // Start from row 2 (after headers)
      
      const imageColumn = "Q";
      var fpath="/api/filedownload/";
      data.forEach((item) => {
  
       
        const signature = `${process.env.REACT_APP_BASE_URL}${fpath}${item.signatureAttachment}`; 
        const farmerphoto = `${process.env.REACT_APP_BASE_URL}${fpath}${item.urlProfile}`; 
        
        
        
         
    
        const rowValues = [
          item.farmerNo   , 
          item.registrationDate,
          item.farmerName,
          item.demoPlotSizeInsqm,
          item.plotSizeInHa,
          item.gender,
          item.mobile,
          // item.bvn,
          item.seasonName,
          // item.farmerStatus,
          item.farmerEducation,
          // item.religion,
          item.dob,
          item.ageRange,
          // item.maritalStatus,
          
          item.category,
          item.address,
          item.state,
          item.lga,
          item.villageName,
          // item.accountNumber,
          // item.accountType,
          // item.bankName,
          item.executiveName,
          item.enrollmentPlace,          
          item.createdDate ? new Date(item.createdDate).toLocaleDateString("en-GB") : "",
          farmerphoto,
          signature
          
        ];
    
        XLSX.utils.sheet_add_aoa(worksheet, [rowValues], {
          origin: `A${currentRowIndex}`,
        });
        
        currentRowIndex++;

        // if (imageUrls.length > 0) {
        //   imageUrls.forEach((url, i) => {
        //     worksheet[`${imageColumn}${currentRowIndex}`] = {
        //       t: "s",
        //       v: url,
        //       l: { Target: url, Tooltip: `Click to view/download image ${i + 1}` },
        //     };
        //     currentRowIndex++;
        //   });
        // } else {
        //   worksheet[`${imageColumn}${currentRowIndex}`] = {
        //     t: "s",
        //     v: "NA",
        //   };
        //   currentRowIndex++;
        // }
      });
    
      worksheet["!cols"] = getColumnWidths(data, headers);
      worksheet["!rows"] = getRowHeights(currentRowIndex);
    
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "FarmerEnrollmentReport");
    
      XLSX.writeFile(workbook, "FarmerEnrollmentTemplate.xlsx", { WTF: true });
    };
    

  // const handleExportExcel = async () => {
  //   const filename = "FarmerEnrollmentTemplate.xlsx";
  //   // console.log(fieldsToExport, customHeaders);
  //   const processedData = data.map((item) => ({
  //     ...item,
  //     farmerphoto: item.urlProfile
  //       ? `${process.env.REACT_APP_FILE_URL}${item.urlProfile}`
  //       : "",
  //     signature: item.signatureAttachment
  //       ? `${process.env.REACT_APP_FILE_URL}${item.signatureAttachment}`
  //       : "",
  //   }));

  //   convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  // };

  
  const { sendRequest: postExportToExcel } = useHttp();
  
  const exportToExcel = (e, includeImages) => {
    e.preventDefault();
    
    const data = {
      stateName: stateName,
      fieldExecutiveId: employeeId,
      farmerNo: farmerNumber,
      fromDate: showDateFilter ? selectedFromDate : "",
      toDate: showDateFilter ? selectedToDate : "",
      orgId: parseInt(localStorage.getItem("orgId")),
      empId: parseInt(localStorage.getItem("empId")),
      includeImages: includeImages,
    };
    postExportToExcel(
      {
        url: `/api/excelFarmerEnrollment/`,
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`You will receive your Excel file on your email shortly`);
      },
      (error) => {
        toast.error("Error...");
      }
    );
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Agri Promoter&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var urlfilter = "";
    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}${urlfilter}`,
      },
      (data) => {
        // console.log("farmerNumberList", data);

        setFarmerData(data);
      }
    );
  }, [employeeId, stateName]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  const excelDownload = async (
    employeeId,
    stateName,
    farmerNo,
    getType = ""
  ) => {
    setLoading(true);

    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `${
      process.env.REACT_APP_BASE_URL
    }/api/farmerEnrolmentReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    try {
      const response = await fetch(url, {
        method: "GET",
        "Content-Type":
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        authorization: `Bearear ${localStorage.getItem("token")}`,
      });

      if (!response.ok) {
        console.error(`Error ${response.status}: ${response.statusText}`);
        setLoading(false);
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);

      console.log(downloadUrl);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "farmerEnrollmentReport.xlsx";
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading file:", error);
    }
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Farmer Enrollment Template
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        // console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillFarmerEnrollmentTemplateData(
                        employeeId,
                        stateName,
                        farmerNumber
                      );
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
              {/* <button
                type="button"
                className="btn btn-sm btn-warning mx-2"
                onClick={(e) => exportToExcel(e, false)}
              >
                <i className="fas fa-file-excel"></i> Excel File Without Images
              </button> */}
              {/* <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={(e) => exportToExcel(e, true)}
              >
                <i className="fas fa-file-excel"></i> Excel File With Images
              </button> */}
        
              {/* <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={(e) => {
                  excelDownload(employeeId, stateName, farmerNumber, "Excel");
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                  </>
                ) : (
                  <>
                    <i className="fas fa-file-image"></i>
                  </>
                )}
              </button> */}
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Farmer No</th>
                          <th>Farmer Photo</th>
                          <th>Registration Date</th>
                          <th>Farmer Name</th>
                          <th>Demo Plot Size(sq.m.)</th>
                          <th>Plot Size(sq.m.)</th>
                          <th>Gender</th>
                          <th>Mobile</th>
                          {/* <th>BVN</th> */}
                          <th>Season</th>
                          {/* <th>Farmer Status</th> */}
                          <th>Education</th>
                          {/* <th>Religion</th> */}
                          <th>DOB</th>
                          <th>Age Range</th>
                          {/* <th>Marital Status</th> */}
                          <th>Category </th>
                          <th>Farmer Address</th>
                          <th>State</th>
                          <th>LGA</th>
                          <th>Village</th>
                          {/* <th>Account Number</th>
                          <th>Account Name</th>
                          <th>Bank Name</th> */}
                          <th>Enrolled By</th>
                          <th>Enrolled Place</th>
                          <th>Signature</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.farmerNo}</td>
                                <td>
                                  <img
                                    src={`${process.env.REACT_APP_FILE_URL}${itm.urlProfile}`}
                                    className="user-image img-circle"
                                    width="60"
                                    height="60"
                                    alt="farmer image"
                                  />
                                </td>
                                <td>{itm.registrationDate}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.demoPlotSizeInsqm}</td>
                                <td>{itm.plotSizeInHa}</td>
                                <td>{itm.gender}</td>
                                <td>{itm.mobile}</td>
                                {/* <td>{itm.bvn}</td> */}
                                <td>{itm.seasonName}</td>
                                {/* <td>{itm.farmerStatus}</td> */}
                                <td>{itm.farmerEducation}</td>
                                {/* <td>{itm.religion}</td> */}
                                <td>{itm.dob}</td>
                                <td>{itm.ageRange}</td>
                                {/* <td>{itm.maritalStatus} </td> */}
                                <td>{itm.category} </td>
                                <td>{itm.address} </td>
                                <td>{itm.state} </td>
                                <td>{itm.lga} </td>
                                <td>{itm.villageName} </td>
                                {/* <td>{itm.accountNumber} </td>
                                <td>{itm.accountType} </td>
                                <td>{itm.bankName} </td> */}
                                <td>{itm.executiveName}</td>
                                <td>{itm.enrollmentPlace}</td>
                                <td>
                                  <img
                                    src={`${process.env.REACT_APP_FILE_URL}${itm.signatureAttachment}`}
                                    className="sign-image img-square"
                                    width="100"
                                    height="100"
                                    alt="sign"
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AgriFarmersEnrollmentTemplate;
